// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"163":"c7bb0863","419":"8c337f7b","563":"e9a0937e"}[chunkId] + ".chunk.js";
};